import React from "react";
import BlogsAside from "../Updates&Blog/BlogsAside";
import BlogImage01 from "../../../../assets/image/image-blog-01.webp";
import BlogImage02 from "../../../../assets/image/image-blog-02.webp";
import Image from "../../../elements/Image";
import useFetch from "../../../../hooks/useFetch";
import { blogDetails } from "../../../../services/BlogService";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import Noimage from "../../../../assets/images/no-image-available.png";
import { classNames } from "../../../../helpers/classNames";
import Quiltext from "../../../elements/Quiltext";
import { toast } from "react-toastify";

const SectionBlogDetails = () => {
  const { slug } = useParams();

  // const BlogDetailsData = {
  //   image: BlogImage01,
  //   title: "10 Effective Study Tips for College Success",
  //   description: "<p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p><p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p><p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p><p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p><p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p><p>At the V’Peters Family Scholarship, we are committed to transforming lives — One Scholarship at a Time. Explore our initiatives below and see the impact of your contributions in shaping the future of aspiring students. Together, we are building a brighter future—one student at a time.</p>",
  //   date: "August 20, 2024",
  //   time: "6:16 am",
  //   postedBy: "Admin",
  // }

  // const BlogsData = {
  //   title: "All Blog",
  //   blogs: [
  //     { _id: 1, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/1" },
  //     { _id: 2, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/2" },
  //     { _id: 3, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/3" },
  //     { _id: 4, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/4" },
  //     { _id: 5, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/5" },
  //     { _id: 6, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/6" },
  //     { _id: 7, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/7" },
  //     { _id: 8, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/8" },
  //     { _id: 9, image: BlogImage02, title: "Can you provide proof of financial need?", link: "/blogs/9" },
  //     { _id: 10, image: BlogImage01, title: "Can you provide proof of financial need?", link: "/blogs/10" },
  //   ]
  // }

  const {
    data: BlogDetailsData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-blog-detaills", slug],
    fetchFunction: async () => {
      const res = await blogDetails({
        slug,
      });
      if (res?.status === 200 || res?.status === 201) {
        return {
          ...res?.data,
          image: res?.data?.image?.url,
          date: dayjs(res?.data?.publishDate)?.format("MMMM DD, YYYY"),
          time: dayjs(res?.data?.publishDate)?.format("hh:mm A"),
          postedBy: "Admin",
        };
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    enabled: !!slug,
  });

  return (
    <>
      <section className="relative flex w-full py-16 xl:py-24 bg-white !pt-40">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="grid grid-cols-12 gap-10">
            <div className="col-span-8 flex">
              <div className="relative block space-y-8">
                <div className="w-full overflow-hidden aspect-[3/2] bg-shades-03">
                  <Image
                    src={BlogDetailsData?.image || Noimage}
                    alt={BlogDetailsData?.title || "blog details"}
                    effect="blur"
                    classes={classNames(
                      !BlogDetailsData?.image
                        ? "scale-[0.7] object-contain"
                        : "object-cover"
                    )}
                  />
                </div>
                <div className="flex items-center gap-10">
                  {BlogDetailsData?.postedBy && (
                    <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
                      <i className="fa-light fa-fw fa-circle-user text-base xls:text-lg xl:text-xl"></i>{" "}
                      By {BlogDetailsData?.postedBy}
                    </div>
                  )}
                  {BlogDetailsData?.date && (
                    <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
                      <i className="fa-light fa-fw fa-calendars text-base xls:text-lg xl:text-xl"></i>{" "}
                      {BlogDetailsData?.date}
                    </div>
                  )}
                  {BlogDetailsData?.time && (
                    <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
                      <i className="fa-light fa-fw fa-clock text-base xls:text-lg xl:text-xl text-chestnut-rose"></i>{" "}
                      {BlogDetailsData?.time}
                    </div>
                  )}
                </div>
                <div className="space-y-8">
                  {BlogDetailsData?.title && (
                    <h2 className="text-3xl font-bold">
                      {BlogDetailsData?.title}
                    </h2>
                  )}
                  {BlogDetailsData?.description && (
                    <Quiltext description={BlogDetailsData?.description} />
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-4 flex">
              <BlogsAside />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionBlogDetails;
